import { css } from 'linaria';

export const newBathroomObjectsCardGrid = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 24px;

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
    gap: 21px;

    :nth-child(3){
      grid-column: auto / span 2;
    }
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    row-gap: 21px;
  }
`;

export const newBathroomObjectsCard = css`
  &:hover {
    a {
      border-color: var(--secondary-yellow-primary);
    }
  }
`;

export const newBathroomObjectsCardImageContent = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  align-items: flex-start;
`;

export const newBathroomObjectsCardImageContainer = css`
  width: 100%;
  height: 240px;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;

  @media (--only-desktop) {
    height: 164px;
  }

  @media (--to-desktop) {
    width: 100%;
    height: 180px;
  }
`;

export const newBathroomObjectsCardImage = css`
  width: 100%;
  height: 100%;

  @media (--only-mobile) {
    height: auto;
  }
`;

export const newBathroomObjectsCardContent = css`
  padding: 24px 24px 28px;
  background-color: #F5F4F1;
  border-radius: 0  0 var(--rounding-l) var(--rounding-l);
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: space-between;
  height: 100%;
  width: 100%;

  @media (--only-desktop) {
    padding: 16px 24px 24px;
  }

  @media (--to-desktop) {
    gap: 21px;
    padding: 19px 16px 24px;
  }
`;

export const newBathroomObjectsCardText = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const newBathroomObjectsCardButton = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const newBathroomObjectsCardButtonLink = css`
  border: 2px solid transparent;
`;
